import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SecondaryHeaderSearchField = ({
  placeholder,
  value,
  onChange,
  onClear,
  onKeyDown
}) => /*#__PURE__*/_jsxs("div", {
  className: "search-wrapper",
  children: [/*#__PURE__*/_jsx("input", {
    type: "search",
    className: "form-control",
    list: "datalistOptions",
    id: "search",
    placeholder: placeholder,
    autoComplete: "off",
    value: value,
    onChange: onChange,
    onKeyDown: onKeyDown
  }), /*#__PURE__*/_jsx("span", {
    className: "search-icon",
    children: /*#__PURE__*/_jsxs("svg", {
      "data-name": "magnify",
      xmlns: "http://www.w3.org/2000/svg",
      width: "13.605",
      height: "13.605",
      viewBox: "0 0 13.605 13.605",
      children: [/*#__PURE__*/_jsx("path", {
        id: "Path_7",
        "data-name": "Path 7",
        d: "M848,133l.971.971",
        transform: "translate(-836.357 -121.357)",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: "1.4"
      }), /*#__PURE__*/_jsxs("g", {
        id: "Ellipse_2",
        "data-name": "Ellipse 2",
        fill: "transparent",
        stroke: "currentColor",
        strokeWidth: "1.4",
        children: [/*#__PURE__*/_jsx("circle", {
          cx: "6.189",
          cy: "6.189",
          r: "6.189",
          stroke: "none"
        }), /*#__PURE__*/_jsx("circle", {
          cx: "6.189",
          cy: "6.189",
          r: "5.489",
          fill: "none"
        })]
      })]
    })
  }), /*#__PURE__*/_jsx("span", {
    className: "btn-clear",
    onClick: onClear,
    role: "button",
    tabIndex: 0,
    children: /*#__PURE__*/_jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "26",
      height: "26",
      viewBox: "0 0 26 26",
      children: /*#__PURE__*/_jsxs("g", {
        id: "close",
        "data-name": "close",
        transform: "translate(-1137 -293)",
        children: [/*#__PURE__*/_jsx("rect", {
          id: "Rectangle_753",
          "data-name": "Rectangle 753",
          width: "26",
          height: "26",
          rx: "13",
          transform: "translate(1137 293)",
          fill: "#f7f8fa"
        }), /*#__PURE__*/_jsxs("g", {
          id: "Group_17821",
          "data-name": "Group 17821",
          transform: "translate(1147.027 303.027)",
          children: [/*#__PURE__*/_jsx("path", {
            id: "Path_21632",
            "data-name": "Path 21632",
            d: "M0,0V8.41",
            transform: "translate(5.947 0) rotate(45)",
            fill: "none",
            stroke: "#13171f",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.7"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_21633",
            "data-name": "Path 21633",
            d: "M0,0V8.41",
            transform: "translate(5.947 5.947) rotate(135)",
            fill: "none",
            stroke: "#13171f",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.7"
          })]
        })]
      })
    })
  })]
});

SecondaryHeaderSearchField.displayName = 'SecondaryHeaderSearchField';
export default SecondaryHeaderSearchField;